<template>
    <div class="tag-relation-type-column">
        <TagThird :label="tagsHuman[type].label" :type="correctedType" size="extra-small" />
    </div>
</template>

<script>
import TagHumansConfig from 'Config/authenticated/TagHumans';
import TagThird from 'vcomponents/common/TagThird/TagThird.vue';

export default {
    name: 'TagRelationTypeColumn',
    components: {
        TagThird,
    },
    props: {
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        tagsHuman() {
            return TagHumansConfig;
        },
        correctedType() {
            return this.type === 'person' ? 'individual' : this.type;
        },
    },
};
</script>
<style scoped lang="scss">
.tag-relation-type-column {
    display: flex;
    align-items: center;
    height: 100%;
}
</style>
